export var ConnectionStateCameraStatus;
(function (ConnectionStateCameraStatus) {
    ConnectionStateCameraStatus["Blocked"] = "blocked";
    ConnectionStateCameraStatus["Error"] = "error";
    ConnectionStateCameraStatus["Success"] = "success";
})(ConnectionStateCameraStatus || (ConnectionStateCameraStatus = {}));
